import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { Option } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import classNames from 'classnames';

import '../about.scss';

type Props = Option & { onClick?: (value: string) => void; testId?: string };

export const InfoItem: FC<Props> = ({ label, onClick, testId, value }) => {
  const { t } = useTranslation();

  return (
    <li>
      <Text color={COLORS.zulu.$08} size="SM" weight="semiBold">
        {t(`ABOUT.${label}`)}
      </Text>
      <Text
        className={classNames('about-version__info', { 'about-version__info--copyable': !!onClick })}
        color={onClick ? COLORS.romeo.$10 : COLORS.zulu.$08}
        size="SM"
      >
        <span data-test={testId} onClick={onClick ? () => onClick(value) : onClick} role="presentation">
          {value}
        </span>
      </Text>
    </li>
  );
};
